// Uploaded files (Required Documents and application documents) must be named after
// their document type, with an optional number for several files of one type:
// Passport.pdf, LOR2.pdf.
// The server enforces the same rules (DOC_NAME_WORDS in backend/server.py),
// so keep both word lists in step. Case, spaces and punctuation are ignored.
const UG_WORDS = ['UGCertificates', 'UG', 'Transcripts', 'Transcript', 'ConsolidatedMarksMemo', 'ConsolidatedMemo', 'CMM',
  'ProvisionalCertificate', 'Provisional', 'PC', 'OriginalDegree', 'OD', 'Degree', 'DegreeCertificate',
  'SemMemos', 'SemMemo', 'SemesterMemos', 'SemesterMemo', 'MarksMemos', 'MarksMemo'];

export const DOC_NAME_WORDS = {
  passport: ['Passport'],
  '10th_certificate': ['10th', '10thCertificate', '10thMemo', '10thMarksMemo', 'SSC', 'Tenth'],
  '12th_certificate': ['12th', 'Intermediate', 'Inter', '12thCertificate', '12thMemo', 'InterMemo', 'HSC'],
  english_scorecard: ['EnglishScore', 'EnglishScorecard', 'EnglishTest', 'IELTS', 'TOEFL', 'PTE', 'Duolingo', 'DET'],
  resume: ['Resume', 'CV'],
  sop: ['SOP', 'StatementOfPurpose'],
  lor: ['LOR', 'LetterOfRecommendation'],
  ug_certificates: UG_WORDS,
  moi: ['MOI', 'MediumOfInstruction'],
  no_backlog_certificate: ['NoBacklog', 'NoBacklogCertificate', 'NBC'],
  offer_letter: ['OfferLetter', 'Offer'],
  conditional_offer: ['ConditionalOffer', 'ConditionalOfferLetter', 'COL'],
  unconditional_offer: ['UnconditionalOffer', 'UnconditionalOfferLetter', 'UCOL'],
  rejection_letter: ['RejectionLetter', 'Rejection'],
  i20: ['I20'],
  visa: ['Visa'],
  scholarship_letter: ['ScholarshipLetter', 'Scholarship'],
};
// 'other' and any type not listed accept any document word.

const norm = (s) => (s || '').toLowerCase().replace(/[^\p{L}\p{N}]/gu, '');

/** Required Documents: the name the file should have, without extension, e.g. "Passport" or "LOR1". */
export const expectedTypeFileName = (docType) =>
  `${DOC_NAME_WORDS[docType]?.[0] || 'DocumentName'}${docType === 'lor' ? '1' : ''}`;

/** Required Documents: null when the file name matches the selected document type
 * (Passport.pdf, LOR2.pdf; anything before an underscore is ignored), otherwise how to rename it. */
export function docTypeNameProblem(fileName, docType) {
  const base = (fileName || '').replace(/\.[^.]+$/, '');
  const words = DOC_NAME_WORDS[docType]?.map(norm);
  const parts = base.split('_');
  for (let i = 0; i < parts.length; i++) {
    const kind = norm(parts.slice(i).join('_'));
    if (!kind) continue;
    if (!words || words.includes(kind) || words.includes(kind.replace(/\d+$/, ''))) return null;
  }
  const ext = /\.[^.]+$/.exec(fileName || '')?.[0] || '';
  return `"${fileName}" doesn't match the selected document type. Rename it to ${expectedTypeFileName(docType)}${ext} and upload again.`;
}
